import { useAuth } from "../../auth/contexts/AuthContext";
import { ROUTES } from '@/constants/routes';

type AuthCta = {
  isAuthenticated: boolean;
  primary: { labelKey: string; href: string };
  secondary: { labelKey: string; href: string } | null;
};

export function useLandingAuthCta(): AuthCta {
  const { isAuthenticated } = useAuth();

  if (isAuthenticated) {
    return {
      isAuthenticated: true,
      primary: { labelKey: "nav.dashboard", href: ROUTES.STANDARDISIERUNG },
      secondary: null,
    };
  }

  return {
    isAuthenticated: false,
    primary: { labelKey: "nav.startFree", href: "/register" },
    secondary: { labelKey: "nav.login", href: "/login" },
  };
}
